import React, { useEffect, useState } from 'react';
import PlacesAutocomplete, {
	geocodeByAddress,
} from 'react-places-autocomplete';
import { getFormItems } from '../../redux/forms/actions';
import { TextField } from '@mui/material';
import styles from './AddressAutocomplete.module.scss';
import { connect } from 'react-redux';
import CustomTextField from '../layout/customTextField/CustomTextField';

function AddressAutocomplete({
	formData,
	setFormData,
	error,
	setError,
	defaultData,
	onChange,
	addressForm,
	optional,
}) {
	const address_inputs = addressForm?.fields;

	const options = {
		types: ['address'],
		componentRestrictions: {
			country: ['ca', 'us'],
		},
	};
	const [expand, setExpand] = useState(defaultData ? true : false);
	useEffect(() => {
		getFormItems('agreement', 'clientInfo');
	}, []);
	const handleSelect = async (value) => {
		let placeArr = value?.split(',');

		const results = await geocodeByAddress(value);
		let addressResult = results[0]?.address_components;
		let types = addressResult[addressResult.length - 1]?.types[0];
		let postal_code = addressResult[addressResult.length - 1]?.long_name;
		let zipCode = types === 'postal_code' ? postal_code : '';

		setFormData({
			...formData,
			address1: placeArr[0],
			city: placeArr[1],
			province: placeArr[2],
			postalCode: zipCode,
			address2: '',
		});

		setExpand(true);

		error?.hasOwnProperty('address1') && delete error['address1'];
		error?.hasOwnProperty('city') && delete error['city'];
		error?.hasOwnProperty('province') && delete error['province'];
		error?.hasOwnProperty('postalCode') && delete error['postalCode'];
	};
	const handleAddressChange = (value) => {
		setExpand(false);

		if (value === '' && !optional) {
			setError({
				...error,
				address1: true,
				city: true,
				province: true,
				postalCode: true,
			});
		} else if (!optional) {
			error?.hasOwnProperty('address1') && delete error['address1'];
			error?.hasOwnProperty('city') && delete error['city'];
			error?.hasOwnProperty('province') && delete error['province'];
			error?.hasOwnProperty('postalCode') && delete error['postalCode'];
		}

		setFormData({
			...formData,
			address1: value,
			city: '',
			province: '',
			postalCode: '',
		});
	};

	return (
		<>
			{address_inputs &&
				address_inputs?.map((field) =>
					field.formName === 'address1' ? (
						<div key={field?.formName}>
							<PlacesAutocomplete
								onSelect={handleSelect}
								value={formData.address1 ?? ''}
								onChange={(value) => handleAddressChange(value)}
								searchOptions={options}
							>
								{({
									getInputProps,
									suggestions,
									getSuggestionItemProps,
									loading,
								}) => (
									<div className={styles.textField}>
										<CustomTextField
											{...getInputProps({
												className:
													'location-search-input',
											})}
											formLabel={field?.formLabel}
											required={
												optional
													? false
													: field?.required
												// field?.required === true
												// 	? true
												// 	: false
											}
											placeholder={field?.formLabel}
											autoComplete='off'
											error={
												error &&
												error[field?.formName] === true
													? true
													: false
											}
											errorMessage={field?.errorMessage}
										/>

										<div
											className={
												styles.autocompleteDropdownContainer
											}
										>
											{loading && <div>Loading...</div>}
											{suggestions.map(
												(suggestion, index) => {
													const className =
														suggestion.active
															? 'suggestion-item--active'
															: 'suggestion-item';
													const style =
														suggestion.active
															? {
																	backgroundColor:
																		'var(--primary-label)',
															  }
															: {
																	backgroundColor:
																		'#ffffff',
															  };
													return (
														<div
															key={index}
															{...getSuggestionItemProps(
																suggestion,
																{
																	className,
																	style,
																}
															)}
															className={
																styles.suggestionContainer
															}
														>
															<span>
																{
																	suggestion.description
																}
															</span>
														</div>
													);
												}
											)}
										</div>
									</div>
								)}
							</PlacesAutocomplete>
						</div>
					) : (
						<div
							className={styles.textField}
							style={
								formData?.address1 !== '' && expand
									? { display: 'block' }
									: { display: 'none' }
							}
							key={field?.formName}
						>
							<CustomTextField
								formLabel={field?.formLabel}
								name={field?.formName}
								value={formData[field?.formName] || ''}
								onChange={(e) => onChange(e)}
								type={field?.formType}
								required={
									optional ? false : field?.required
									// field?.required === true ? true : false
								}
								error={
									error && error[field?.formName] === true
										? true
										: false
								}
								errorMessage={field?.errorMessage}
							/>
						</div>
					)
				)}
		</>
	);
}
const mapStateToProps = (state) => ({
	addressForm:
		state.forms.form.clientInfo?.address ||
		state.forms.form?.clientDetails?.purchaser?.address,
});

export default connect(mapStateToProps, {
	getFormItems,
})(AddressAutocomplete);
